module.exports = __webpack_public_path__ + "img/icon_deposit.6e760a8.webp";